/*
 * FORWRD homepage scripts — extracted from templates/index.json :: custom_liquid_fmYHrF
 * (May 2026 SEO/perf cleanup). The custom-liquid section's `liquid` setting is capped
 * at 50KB; pulling these scripts into an asset keeps the section under the cap.
 *
 * Loaded via:
 *   <script src="{{ 'forwrd-homepage.js' | asset_url }}" defer></script>
 *
 * `defer` is safe because all callers (toggleFaq, loadVideo) are referenced by inline
 * onclick handlers that can only fire after the document has parsed; defer guarantees
 * this script runs before DOMContentLoaded but after parsing completes.
 *
 * KNOWN TODO: replace the literal VIDEO_ID inside loadVideo() with the real YouTube ID
 * for the Court Caddy "What's Inside" video. Until done, the play button is broken.
 */
// Scroll-triggered fade-in for all sections
(function() {
  var sections = document.querySelectorAll('.fade-in-section');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  sections.forEach(function(s) { observer.observe(s); });
})();

// FAQ accordion
function toggleFaq(btn) {
  var item = btn.parentElement;
  var answer = item.querySelector('.faq-answer');
  var isOpen = item.classList.contains('open');

  // Close all
  document.querySelectorAll('.faq-item.open').forEach(function(openItem) {
    openItem.classList.remove('open');
    openItem.querySelector('.faq-answer').style.maxHeight = null;
  });

  // Toggle current
  if (!isOpen) {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }
}

// Sticky mobile CTA — appears after scrolling past hero
(function() {
  var sticky = document.getElementById('sticky-mobile-cta');
  if (!sticky) return;
  var threshold = 600;
  window.addEventListener('scroll', function() {
    var y = window.pageYOffset;
    if (y > threshold) {
      sticky.classList.add('show');
    } else {
      sticky.classList.remove('show');
    }
  }, { passive: true });
})();

// Video facade loader
function loadVideo(wrapper) {
  wrapper.classList.add('video-iframe-active');
  var iframe = document.createElement('iframe');
  // TODO: replace VIDEO_ID with the actual YouTube ID for the Court Caddy "What's Inside" overview video
  iframe.src = 'https://www.youtube.com/embed/VIDEO_ID?autoplay=1&rel=0';
  iframe.allow = 'autoplay; encrypted-media';
  iframe.allowFullscreen = true;
  wrapper.appendChild(iframe);
}
